<template>
  <div class="container page service-online-page">
    <div class="header">
      <van-nav-bar :title="$t('my.online_service')" class="nav-bar">
        <template #left>
          <button class="nav-back" type="button" aria-label="Back" @click="back()">
            <van-icon name="arrow-left" />
          </button>
        </template>
      </van-nav-bar>
    </div>
    <main class="service-content">
      <section class="servicelistItem" aria-label="Victoria customer service">
        <div class="servicelistItemTop">
          <div class="service-avatar">
            <img class="servicelistItemImage" src="img/mine/kefu.png" alt="Customer service">
            <span class="online-dot" aria-label="Online"></span>
          </div>
          <div class="service-copy">
            <div class="servicelistItemText">{{ $brand.name }}</div>
            <div class="service-status">Private member assistance</div>
          </div>
          <button class="servicelistItemBtn" type="button" @click="toServicePage()">
            <span class="servicelistItemBtnText">
              {{$t("my.contact")}}
            </span>
            <van-icon name="arrow" />
          </button>
        </div>
        <div class="servicelistItemBottom">
          <van-icon name="clock-o" />
          <div class="servicelistItemInfoText">
            {{$t("my.service_time")}}
          </div>
        </div>
      </section>
      <div class="service-note">
        <van-icon name="shield-o" />
        <span>Secure, discreet support for Victoria members.</span>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toServicePage(){
      const service = this.$store.getters.getBaseInfo;
      console.log(service)
      if (service.iskefu == 1){
        console.log('ssss')
        window.location.href = service.kefu
      }
      // this.$router.push("ServicePage");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.servicelistItem{
  display: flex;
  flex-direction: column;
  height: 2rem;
  padding: 0.3rem 0.3rem;
  margin: 0.3rem 0.2rem;
  border-radius: 0.2rem;
  justify-content: space-between;
  background: #fff;
}
.servicelistItem .servicelistItemTop{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 1rem;
}
.servicelistItem .servicelistItemTop .servicelistItemImage{
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
}
.servicelistItem .servicelistItemTop .servicelistItemText{
  margin-left: 0.5rem;
  font-size: 0.43rem;
  font-weight: 700;
  color: #000;
  flex: 1;
}
.servicelistItem .servicelistItemTop .servicelistItemBtn{
  display: flex;
  width: 1.5rem;
  height: 0.55rem;
  border-radius: 0.3rem;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
      270deg,#5b60df,#5b60df);
}
.servicelistItem .servicelistItemTop .servicelistItemBtn .servicelistItemBtnText{
  color: #fff;
  font-size: 0.25rem;
}
.servicelistItem .servicelistItemBottom{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.5rem;
  background: #f2f2f5;
  border-radius: 0.1rem;
  color: #979799;
}
.servicelistItem .servicelistItemBottom .servicelistItemInfoText{
  font-size: 0.3rem;
}

/* Victoria Dating Club UI2 */
.service-online-page {
  color: var(--victoria-text);
  background: transparent;
}

.service-online-page .nav-back {
  display: inline-flex;
  width: 0.88rem;
  height: 0.88rem;
  margin-left: -0.2rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-text);
  background: transparent;
  border: 0;
  border-radius: 50%;
}

.service-online-page .service-content {
  width: 100%;
  padding: 0.34rem 0.28rem max(0.5rem, env(safe-area-inset-bottom));
}

.service-online-page .servicelistItem {
  display: flex;
  width: 100%;
  height: auto;
  min-height: 3rem;
  margin: 0;
  padding: 0.42rem;
  gap: 0.36rem;
  justify-content: flex-start;
  color: var(--victoria-text);
  background: linear-gradient(145deg, rgba(48, 37, 44, 0.94), rgba(20, 17, 21, 0.94));
  border: 1px solid var(--victoria-border);
  border-radius: 0.46rem;
  box-shadow: var(--victoria-shadow);
  backdrop-filter: blur(16px);
}

.service-online-page .servicelistItem .servicelistItemTop {
  width: 100%;
  height: auto;
  min-height: 1.3rem;
  gap: 0.26rem;
}

.service-online-page .service-avatar {
  position: relative;
  width: 1.18rem;
  height: 1.18rem;
  flex: 0 0 auto;
  padding: 0.18rem;
  background: rgba(255, 209, 217, 0.1);
  border: 1px solid rgba(231, 160, 174, 0.26);
  border-radius: 50%;
}

.service-online-page .servicelistItem .servicelistItemTop .servicelistItemImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 0;
  filter: sepia(0.35) saturate(0.75) brightness(1.35);
}

.service-online-page .online-dot {
  position: absolute;
  right: 0.02rem;
  bottom: 0.08rem;
  width: 0.26rem;
  height: 0.26rem;
  background: var(--victoria-primary);
  border: 0.06rem solid #2a2026;
  border-radius: 50%;
  box-shadow: 0 0 0.22rem rgba(231, 160, 174, 0.75);
}

.service-online-page .service-copy {
  min-width: 0;
  flex: 1;
}

.service-online-page .servicelistItem .servicelistItemTop .servicelistItemText {
  margin: 0 0 0.08rem;
  color: var(--victoria-text);
  font-family: var(--victoria-font-ui);
  font-size: 0.42rem;
  line-height: 1.3;
}

.service-online-page .service-status {
  color: var(--victoria-text-muted);
  font-size: 0.27rem;
  line-height: 1.4;
}

.service-online-page .servicelistItem .servicelistItemTop .servicelistItemBtn {
  display: inline-flex;
  width: auto;
  min-width: 1.82rem;
  height: 0.78rem;
  padding: 0 0.24rem;
  gap: 0.08rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: #29191e;
  background: var(--victoria-action);
  border: 0;
  border-radius: 999px;
  box-shadow: 0 0.16rem 0.4rem rgba(207, 127, 145, 0.25);
}

.service-online-page .servicelistItem .servicelistItemTop .servicelistItemBtnText {
  color: inherit;
  font-size: 0.28rem;
  font-weight: 700;
}

.service-online-page .servicelistItem .servicelistItemBottom {
  width: 100%;
  height: auto;
  min-height: 0.82rem;
  padding: 0.15rem 0.22rem;
  gap: 0.12rem;
  color: var(--victoria-text-muted);
  background: rgba(8, 6, 9, 0.48);
  border: 1px solid var(--victoria-divider);
  border-radius: 0.26rem;
}

.service-online-page .servicelistItemBottom .van-icon {
  color: var(--victoria-primary);
  font-size: 0.38rem;
}

.service-online-page .servicelistItem .servicelistItemBottom .servicelistItemInfoText {
  font-size: 0.28rem;
  line-height: 1.4;
}

.service-online-page .service-note {
  display: flex;
  width: calc(100% - 0.3rem);
  margin: 0.32rem auto 0;
  gap: 0.14rem;
  align-items: center;
  justify-content: center;
  color: var(--victoria-text-muted);
  font-size: 0.27rem;
  line-height: 1.5;
  text-align: center;
}

.service-online-page .service-note .van-icon {
  color: var(--victoria-primary);
  font-size: 0.4rem;
}

.service-online-page button:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

@media (max-width: 340px) {
  .service-online-page .servicelistItem .servicelistItemTop {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .service-online-page .servicelistItem .servicelistItemTop .servicelistItemBtn {
    width: 100%;
    margin-top: 0.12rem;
  }
}
</style>
